import { handleError } from './utils';

// eslint-disable-next-line no-return-await
export const getDownloadLink = (id, platform) => handleError(async (dispatch, getState, { api }) => {
  const download = await api.getDownloadLink(id, platform);
  return download;
}, 'There was a problem when trying to get link');
